module.exports = __webpack_public_path__ + "img/barcel.0c5beb16.png";